// LA PORTADA PUBLICA, la de `academialpha.com` sin cuenta. No confundir con
// `portadaDelMundo.js`, que es la plaza del Mundo 3D de quien ya ha entrado: aquella sirve
// `/api/mundo/*` y esta `/api/portada/*`. Dos sitios distintos con nombres parecidos, y por
// eso se dice aqui en vez de dejarlo a la suerte del que busque.
import { api } from "./client";

// LA LECCION DE MUESTRA, entera y sin sesion. Da 404 cuando no hay ninguna marcada, que es
// el estado normal y no una averia: la portada se queda sin ese bloque y ya.
export const getMuestra = async () => (await api.get("/portada/muestra")).data;

// Y la elige el admin desde el CMS. El servidor contesta 400 con el motivo escrito si esa
// leccion no esta publicada o no es de las que el plan gratis ya abre.
export const ponMuestra = async (lessonId) =>
  (await api.put("/portada/muestra", { lesson_id: lessonId })).data;
